import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteSettingsContext = createContext(null);

export function SiteSettingsProvider({ children }) {
  // Live-store default: production has flipped prelaunch off. Keeping
  // the default `false` avoids a flash of prelaunch UI during the
  // initial /api/site-settings fetch. If the server later confirms a
  // re-enabled prelaunch window, the effect below will swap it back in.
  const [settings, setSettings] = useState({ prelaunch_mode: false });
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/site-settings")
      .then(({ data }) => setSettings(data || {}))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  return (
    <SiteSettingsContext.Provider value={{ settings, loaded, isPrelaunch: !!settings.prelaunch_mode }}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export const useSiteSettings = () => useContext(SiteSettingsContext);
